module.exports = __webpack_public_path__ + "static/media/lesson plan.64bd9d12.svg";